
<template>

    <div class="Paging Noselect">
        <div class="RecordPrePageGroup">
            <select v-model.number="RecordPerPage" type="number" @change="OnRecordPrePageChange">

                <option v-if="RecordPerPage != null && RecordPerPage%10 !=0">{{RecordPerPage}}</option>
                <option value="5">5</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="10">12</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
                <option value="5000">5000</option>
            </select>
        </div>
        <div>
            <div class="PageNumber First" @click="OnFirstPageButtonClick">
                <<
            </div>
            <div class="PageNumber Previous" @click="OnPreviousPageButtonClick">
                <
            </div>
            <div v-for="i in PageNumbers" class="PageNumber" :class="{ 'Current':(CurrentPageNumber == i)}"
                 @click="OnPageButtonClick(i)">
                {{i}}
            </div>
            <div class="PageNumber Next" @click="OnNextPageButtonClick">
                >
            </div>
            <div class="PageNumber Last" @click="OnLastPageButtonClick">
                >>
            </div>

            <div class="TotalCountGroup">
                總數 {{ TotalCount }}
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        data() {
            return {
                PageNumbers: [],
                StartPageNumber: 0,
                EndPageNumber: 0,
                PageCount: 0,
                TotalCount: 0,
                RecordPerPage: 10,
                CurrentPageNumber: 1,
                ItemListContainerSelector: "",
            }
        }
        ,

        props: ["PagingData"],

        computed: {

        }
        ,

        methods: {


            OnRecordPrePageChange() {

                this.ResetByCurrentPageNumber(1);
                this.$emit("change", this.$data);
            },

            OnFirstPageButtonClick() {

                this.ResetByCurrentPageNumber(1);

                this.ScrollToItemListContainer();
                this.$emit("change", this.$data);
            },

            OnPreviousPageButtonClick() {
                if (this.CurrentPageNumber > 1) {
                    this.ResetByCurrentPageNumber(this.CurrentPageNumber - 1);
                    this.ScrollToItemListContainer();
                    this.$emit("change", this.$data);
                }
            },

            OnPageButtonClick: function (pageNumber) {
                //alert(pageNumber);

                this.ResetByCurrentPageNumber(pageNumber);
                this.ScrollToItemListContainer();
                this.$emit("change", this.$data);
            },

            OnNextPageButtonClick() {

                if (this.CurrentPageNumber < this.EndPageNumber) {
                    this.ResetByCurrentPageNumber(this.CurrentPageNumber + 1);
                    this.ScrollToItemListContainer();
                    this.$emit("change", this.$data);
                }
            },

            OnLastPageButtonClick() {
                if (this.CurrentPageNumber < this.EndPageNumber) {
                    this.ResetByCurrentPageNumber(this.PageCount);
                    this.ScrollToItemListContainer();
                    this.$emit("change", this.$data);
                }
            },

            ResetByCurrentPageNumber(currentPageNumber) {
                let startPageNumber, endPageNumer;
                let halfMaxPageButtonCount = 8;
                //let currentPageNumber = parseInt(this.CurrentPageNumber);
                let recordPerPage = parseInt(this.RecordPerPage);
                let totalCount = parseInt(this.TotalCount);
                let pageCount;
                let i;


                pageCount = Math.ceil(totalCount / recordPerPage);

                if ((halfMaxPageButtonCount - 1) < currentPageNumber) {
                    startPageNumber = currentPageNumber - (halfMaxPageButtonCount - 1);
                }
                else {
                    startPageNumber = 1;
                }

                if (currentPageNumber + halfMaxPageButtonCount < pageCount) {
                    endPageNumer = currentPageNumber + halfMaxPageButtonCount;
                }
                else {
                    endPageNumer = pageCount;
                }

                this.PageNumbers.length = 0;
                for (i = startPageNumber; i <= endPageNumer; i++) {
                    this.PageNumbers.push(i);
                }

                this.StartPageNumber = startPageNumber;
                this.EndPageNumber = endPageNumer;
                this.PageCount = pageCount;
                this.CurrentPageNumber = currentPageNumber;
            },


            ScrollToItemListContainer() {
                let itemListContainerElement;
                let clientTop;

                if (this.ItemListContainerSelector != "" && this.ItemListContainerSelector != null) {
                    itemListContainerElement = document.querySelector(this.ItemListContainerSelector);

                    if (itemListContainerElement != null) {
                        clientTop = this.$util.GetClientTop(itemListContainerElement);
                        if (clientTop > 20) {
                            clientTop -= 20;
                        }

                        setTimeout(
                            function () {
                                this.$util.ResetImagesOrientation(itemListContainerElement);
                            }.bind(this),
                            300
                        );

                        setTimeout(
                            function () {
                                this.$util.ResetImagesOrientation(itemListContainerElement);
                            }.bind(this),
                            1000
                        );

                        setTimeout(
                            function () {
                                window.scrollTo(0, clientTop);
                            }.bind(this),
                            500
                        );

                    }
                }
            },
        },

        created() {

            this.CurrentPageNumber = this.PagingData.CurrentPageNumber;
            this.RecordPerPage = this.PagingData.RecordPerPage;
            this.TotalCount = this.PagingData.TotalCount;
            this.ItemListContainerSelector = this.PagingData.ItemListContainerSelector;

            this.ResetByCurrentPageNumber(this.CurrentPageNumber);
        },

        watch: {

            PagingData: function (newVal, oldVal) { // watch it

                if (newVal != null) {
                    this.CurrentPageNumber = newVal.CurrentPageNumber;
                    this.RecordPerPage = newVal.RecordPerPage;
                    this.TotalCount = newVal.TotalCount;
                    if (newVal.ItemListContainerSelector != null) {
                        this.ItemListContainerSelector = newVal.ItemListContainerSelector;
                    }
                }

                this.ResetByCurrentPageNumber(this.CurrentPageNumber);
            },

            TotalCount: function (newVal, oldVal) { // watch it

            }
        }


    }
</script>

<style scoped>

    .Paging {
        display: block;
        text-align: center;
        font-size: 0px;
    }

        .Paging DIV.RecordPrePageGroup {
            margin-right: 10px;
        }

            .Paging DIV.RecordPrePageGroup SELECT {
                line-height: 30px;
                height: 30px;
                font-size: 14px;
            }

        .Paging > DIV {
            text-align: left;
            margin-left: auto;
            margin-right: auto;
            padding-left: 2px;
            display: inline-block;
        }

    .PageNumber {
        border: 1px solid lightgray;
        color: rgb(154,136,170);
        min-width: 30px;
        height: 30px;
        line-height: 30px;
        display: inline-block;
        text-align: center;
        margin: 0px;
        cursor: pointer;
        background-color: White;
        margin-left: -1px;
        font-size: 13px;
        padding-left: 2pX;
        padding-right: 4pX;
    }

        .PageNumber:hover {
            background-color: rgb(235,235,235);
        }

        .PageNumber.Current {
            border: 1px solid lightgray;
            min-width: 30px;
            height: 30px;
            display: inline-block;
            text-align: center;
            font-weight: bold;
            background-color: rgb(92,69,69);
            color: white;
            margin-left: -1px;
        }

        .PageNumber.OnlyOne {
            color: rgb(154,136,170);
            background-color: White;
        }

        .PageNumber.Current:hover {
            background-color: rgb(100,79,79);
            color: white;
        }


    .TotalCountGroup {
        display: inline-block;
        font-size: 14PX;
        font-family: "微軟正黑體";
        margin-left: 10px;
    }


    .MoveToFirstButton {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
    }

    .MoveToPreviousButton {
        cursor: pointer;
        margin-left: -1px;
    }




    .MoveToNextButton {
        margin-left: -1px;
    }

    .MoveToEndButton {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        margin-left: -1px;
    }

    .paging .TotalCountParameter {
        display: none;
    }



    @media screen and (max-width:860px) {
        .Paging DIV.RecordPrePageGroup, .TotalCountGroup {
            display: none;
        }
    }
</style>
